import { PropsWithChildren } from 'react';
import styled from 'styled-components';

type SecondaryProps = {
  centered?: boolean;
};

export const StyledTwoColumnGrid = styled.div`
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 48px;
  row-gap: 0px;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 160px;
  width: 100%;

  ${props => props.theme.media.tabletLandscapeDown} {
    padding: 0;
  }

  ${props => props.theme.media.largeScreenUp} {
    max-width: 1700px;
  }
`;

const Primary = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  margin: 0 auto;
  max-width: 480px;
  padding-bottom: 120px;
  width: 100%;

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }

  ${props => props.theme.media.tabletLandscapeUp} {
    grid-column: 1 / 1;
  }

  ${props => props.theme.media.tabletLandscapeDown} {
    padding: 40px 16px 48px;
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 0 24px 48px;
  }

  & > :first-child {
    margin-top: 0;
  }
`;

const MobileOnlySecondary = styled.div`
  display: none;

  ${({ theme }) => theme.media.tabletLandscapeDown} {
    //grid-column: 2;
    display: flex;
    flex-direction: column;
    grid-column: 1 / -1;
    margin: 0 auto;
    padding-bottom: 120px;
    width: 100%;
    max-width: 600px;
  }
`;

const Secondary = styled.div<SecondaryProps>`
  ${props => props.theme.media.tabletLandscapeDown} {
    display: none;
  }

  ${props => props.theme.media.tabletLandscapeUp} {
    grid-column: 2;
  }

  max-width: 360px;
  margin: 0 auto;
  padding-bottom: 120px;

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }

  ${({ centered }) =>
    centered &&
    `
    align-items: center;
    display: flex;
    padding-bottom: 0px;
  `}
`;

const Navigation = styled.div`
  margin: 0 auto 48px;
  grid-column: 1 / -1;
  width: 100%;
  max-width: 480px;

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }

  ${props => props.theme.media.tabletLandscapeUp} {
    grid-column: 1;
  }

  ${props => props.theme.media.tabletLandscapeDown} {
    padding: 40px 16px 0;
    margin-bottom: 8px;
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 0 24px;
    margin-bottom: 24px;
  }
`;

export const TwoColumnGrid = ({ children, testId }: PropsWithChildren<{ testId?: string }>) => (
  <StyledTwoColumnGrid data-testid={testId}>{children}</StyledTwoColumnGrid>
);

TwoColumnGrid.Primary = Primary;
TwoColumnGrid.Secondary = Secondary;
TwoColumnGrid.Navigation = Navigation;
TwoColumnGrid.MobileOnlySecondary = MobileOnlySecondary;
